export default {
    required: "É necessário inserir um valor.",
    email: "O valor não é um endereço de e-mail válido.",
    mask: "O valor é inválido.",
    maxValue: "O valor máximo é {max}",
    maxLength: "O comprimento máximo permitido é {max}",
    regex: "O valor é inválido.",
    server: {
        DELEGATES_NOT_ENABLED: "A delegação não está habilitada para este parceiro.",
        DELEGATE_DOES_NOT_EXIST: "O delegado não existe.",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "Não é possível atualizar um delegado que não lhe pertence.",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "Não é possível excluir um delegado que não lhe pertence.",
        DELEGATE_ALREADY_EXISTS: "Já existe uma regra de delegação que corresponde a esses critérios.",
        DELEGATE_CANNOT_BE_SELF: "Você não pode se adicionar como delegado.",
        IMPERSONATE_USER_NO_PERMISSIONS: "O usuário {email} não tem acesso a DXC Equipamentos e nenhum pedido pode ser feito em seu nome.",
        INVALID_CART_ITEM: "Produto {product} não permitido",
        INVALID_USER_TYPE: "O tipo de usuário não é um funcionário.",
        INVALID_EMPLOYMENT_STATUS: "O usuário não é um funcionário ativo.",
        USER_NOT_FOUND: "O usuário não existe.",
        "Invalid user type": "Tipo de usuário inválido",
        "User not found": "Usuário não encontrado"
    }
}